module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.be/nl_be/bedrijf/privacy.html",
	"footer.disclaimer.text": "Disclaimer",
	"footer.disclaimer.url": "https://www.grohe.be/nl_be/bedrijf/privacy.html",
	"footer.copyright": "&copy; Grohe N.V. - S.A.",
	"homepage.headline": "GROHE Watersystemen Configurator",
	"homepage.introtext": "Beantwoord een paar simpele vragen in de keuzehulp en ontdek welk GROHE watersysteem het beste bij jouw wensen past of welke combinatie je kan maken.",
	"homepage.buttonStart": "Start",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Pagina niet gevonden",
	"404.link.goBack": "Ga terug naar de homepagina",
	"configurator.button.seeResults": "Bekijk resultaten",
	"question1.question": "Heb je koud en warm water voorziening in jouw keuken?",
	"question1.option1.text": "Ik heb warm water toevoer in mijn keuken",
	"question1.option2.text": "Ik heb enkel koud water toevoer in mijn keuken",
	"question2.question": "Naar wat voor water oplossing ben je op zoek?",
	"question2.option1.text": "Kokend heet water voor het bereiden van voedsel en dranken",
	"question2.option2.text": "Gekoeld en bruisend water om te drinken",
	"question2.option3.text": "Zowel gekoeld en bruisend water als kokend heet water",
	"question3.question": "Wil je jouw bestaande keukenkraan houden?",
	"question3.option1.text": "Ik wil mijn huidige kraan houden",
	"question3.option2.text": "Ik wil mijn huidige kraan vervangen door een nieuwe",
	"question4.question": "Wat zou de belangrijkste kraan moeten zijn?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Wat is jouw favoriete uitloop?",
	"question5.option1.text": "L-vorm",
	"question5.option2.text": "U-vorm",
	"question5.option3.text": "C-vorm",
	"question6.question": "What´s your prefered spout design for the Mono faucet?",
	"question6.option1.text": "L-vorm",
	"question6.option2.text": "C-vorm",
	"question7.question": "Naar welke afwerking gaat jouw voorkeur uit?",
	"question7.option1.text": "Chroom",
	"question7.option2.text": "Supersteel",
	"question8.question": "Hoeveel liter kokend water heb je nodig?",
	"question8.option1.text": "M Size (3 liter)",
	"question8.option2.text": "L Size (5,5 liter)",
	"question9.question": "Would you like to have an additional filter to soften and enhance the water? (only applicable for NL)",
	"question9.option1.text": "Yes",
	"question9.option2.text": "No",
	"results.title": "Jouw {productGroupsCount, plural, \none {resultaat} \nother {resultaten}\n}",
	"results.proposal.title": "Voorstel {number}",
	"results.proposal.title.single": "Voorstel",
	"results.bundle.title": "Voor een correcte installatie heb je ook het volgende nodig",
	"results.newConfiguration.title": "Wil je een nieuwe configuratie maken?",
	"results.newConfiguration.buttonText": "Configureer een nieuw watersysteem",
	"results.product.number": "Referentie: #{number}",
	"results.product.button.productInformation": "Product informatie",
	"results.product.button.dealerLocator": "Vind showroom",
	"results.product.button.buyNow": "Buy Now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product informatie",
	"results.product.dealer": "Vind showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.nl_be.json
// module id = 787
// module chunks = 0